import { loggerService } from '../../../common/helpers/logger';

import type { APIMiddlewareResponse } from './APIMiddlewareResponseLogMapper';
import { createAPIMiddlewareResponseLogMapper } from './APIMiddlewareResponseLogMapper';

export function createAPIMiddlewareLogger({ name }: { name: string }) {
  const mapper = createAPIMiddlewareResponseLogMapper({
    loggerName: name,
  });

  return (
    response: APIMiddlewareResponse,
    err: Error | null,
    duration: number,
  ) =>
    loggerService.log(
      mapper.toDto(
        response,
        { duration },
        err?.message || response?.error?.message || 'Unknown Message',
      ),
    );
}
